import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';

import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule as FormModule, ReactiveFormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';

import {OrderRoutingModule} from './order-routing.module';
import {OrderComponent} from './order.component';
import {DialogOverviewComponent} from './dialog-overview/dialog-overview.component';
import {CheckboxComponent} from './checkbox/checkbox.component';
import {DatePickerComponent} from './date-picker/date-picker.component';
import {FormFieldComponent} from './form-field/form-field.component';
import {ViewdetailsComponent} from './viewdetails/viewdetails.component';
import {OrderseserviceService} from './orderseservice.service';
import {MatNativeDateModule} from '@angular/material/core';

@NgModule({
  imports: [CommonModule, OrderRoutingModule, FlexLayoutModule, MatCardModule, CommonModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    FormModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSliderModule,
    MatButtonModule
  ],
  declarations: [
    OrderComponent,
    DialogOverviewComponent,
    CheckboxComponent,
    DatePickerComponent,
    FormFieldComponent,
    ViewdetailsComponent,
  ],
  entryComponents: [
    DialogOverviewComponent,
    ViewdetailsComponent
  ],
  providers: [OrderseserviceService]
})
export class OrderModule {
}
